<script>
import { defineAsyncComponent } from 'vue';
import "@common/syncfusionCss";
import { configStore } from "@common/configStore";
import { componentStore } from "@common/componentStore/componentStore";
import { controlStore, createStoreIndex } from "@common/control/controlStore";
import { ddStore } from "@common/ddStore";
import { library } from "@common/library/library";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const editorSettings = {};

let mainGridCfg = {
    cId: "mainGrid",
    cType: "mainGrid",
    cTitle: "Main Grid",
    cTemplate: `<div oncontextmenu="return false">
                    <div name="MainGrid" id="mainGrid">
                        <div class="top-menu">
                            <menu-bar :c-id="'menuBar_mainGrid'" :prop-menu-action="doMenuAction"></menu-bar>
                        </div>
                        <div id="main-grid-content">
                            <div class="logo-area">
                                <img v-if="logoUrl" id="logo" alt="eCoordinator Account Logo" :src="logoUrl"/>
                            </div>
                            <div class="account-title" id="account_title">
                               &nbsp;{{accountName}}
                               <span id="folder_title" v-if="showFolderNameInTitle"> : <img alt="" border="0" name="folder_image" src="../common/images/folder_ico.png">
                                    <span id="folder_title_field">{{ selectedFolder && selectedFolder[selectedTab] ? selectedFolder[selectedTab].DATA_VIEW_NAME : ''}}</span>
                               </span>
                            </div>
                            <div id="tcmain">
                                <div class="main-tabcontrol-tabline">
                                    <div v-for="(option, index) in tabs" :key="index">
                                        <input type="button" :title="option.title" :value="option.title" :id="option.FF_NAME" :class="{'tabcontrol-tab': true, 'active': selectedTab === option.FF_CONSTANT}" @click="processTab(option.FF_CONSTANT)">
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="form-border">
                                    <div class="form-area">
                                        <br/>
                                        <div id="grid-main-content">
                                            <div v-if="selectedTab === 'COORD_DASHBOARD'">
                                                <layout-container :c-id="accountSettings.ACCOUNT_EC_DASHBOARD_ID"></layout-container>
                                            </div>
                                            <div v-else>
                                                <div id="grid-main-content-inner">
                                                    <div id="leftpanel">
                                                        <div id="ACTION_BUTTONS" v-if="!reloadButtons && selectedTab !== 'COORD_PRO'">
                                                            <div v-for="(option, index) in leftMenu[selectedTab]" :key="index">
                                                                <div class="inputButtonWrapper">
                                                                    <control :name="option.value"
                                                                        :onclick="leftMenuAction"
                                                                        :items="leftMenuItems(option)"
                                                                    >
                                                                    </control>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="selectedTab === 'COORD_PRO' && gridLoaded[selectedTab]">
                                                            <teleport v-for="(option, index) in leftMenu[selectedTab]" :key="index" :to="'#professionsButtons'">
                                                                <div id="ACTION_BUTTONS">
                                                                    <div class="inputButtonWrapper">
                                                                        <control :name="option.value"
                                                                            :onclick="leftMenuAction"
                                                                            :items="leftMenuItems(option)"
                                                                        >
                                                                        </control>
                                                                    </div>
                                                                </div>
                                                            </teleport>
                                                            <div class="clearfix"></div>
                                                            <div class="proOpp">
                                                                <control name="proOppFolders" :items="proOppFolders" :value="proOppSelectedFolder" @update:value="proOppSelectedFolder = $event; disableControls(); reloadGrid('grid_mainGrid__COORD_PRO_OPP');" ></control>
                                                            </div>
                                                            <div class="proPlace">
                                                                <control name="proReferCheckbox"></control>
                                                                <control name="proReferButton"></control>
                                                                <control name="proPlaceCheckbox"></control>
                                                                <control name="proPlaceButton"></control>
                                                            </div>
                                                            <div class="clearfix"></div>
                                                            <grid :c-id="'grid_mainGrid__COORD_PRO_OPP'"
                                                                        :ref="'grid_mainGrid__COORD_PRO_OPP'"
                                                                        :prop-psp="2"
                                                                        :prop-from-psp="14"
                                                                        :prop-is-list="true"
                                                                        :prop-selected-folder="proOppSelectedFolder"
                                                                        :prop-selected-items="selectedItems['COORD_PRO_OPP']"
                                                                        @update:prop-selected-items="selectedItems['COORD_PRO_OPP'] = $event; disableControls()"
                                                                        :prop-selected-items-full-data="selectedItemsFullData['COORD_PRO_OPP']"
                                                                        @update:prop-selected-items-full-data="selectedItemsFullData['COORD_PRO_OPP'] = $event;"
                                                                        ></grid>
                                                        </div>
                                                        <div id="folder_core_area_div">
                                                            <div id="folder_area_table">
                                                                <div v-for="(option, index) in tabs" :key="index">
                                                                    <div v-if="selectedTab === option.FF_CONSTANT || alreadyShownTabs[option.FF_CONSTANT]" v-show="selectedTab === option.FF_CONSTANT">
                                                                        <folders-manager
                                                                            :c-id="'foldersManager_mainGrid__' + option.FF_CONSTANT"
                                                                            ref="foldersManeger"
                                                                            :prop-selected-folder="selectedFolder[selectedTab]"
                                                                            @update:prop-selected-folder="selectedFolder[selectedTab] = $event; disableControls()"
                                                                            :prop-selected-items="selectedItemsFullData[selectedTab]"
                                                                            :prop-psp="option.psp"
                                                                            ></folders-manager>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id="rightpanel">
                                                        <div v-for="(option, index) in tabs" :key="index">
                                                            <div v-if="selectedTab === option.FF_CONSTANT || alreadyShownTabs[option.FF_CONSTANT]" v-show="selectedTab === option.FF_CONSTANT">
                                                                <div id="gridWrapper"  :style="{ 'height': gridWrapperHeight }">
                                                                    <grid :c-id="'grid_mainGrid__' + option.FF_CONSTANT"
                                                                        :ref="'grid_mainGrid__' + option.FF_CONSTANT"
                                                                        :prop-psp="option.psp"
                                                                        :prop-selected-folder="selectedFolder[option.FF_CONSTANT]"
                                                                        @update:prop-selected-folder="selectedFolder[option.FF_CONSTANT] = $event;"
                                                                        :prop-selected-items="selectedItems[option.FF_CONSTANT]"
                                                                        @update:prop-selected-items="selectedItems[option.FF_CONSTANT] = $event; disableControls()"
                                                                        :prop-selected-items-full-data="selectedItemsFullData[option.FF_CONSTANT]"
                                                                        @update:prop-selected-items-full-data="selectedItemsFullData[option.FF_CONSTANT] = $event;"
                                                                        :prop-load-func="onGridLoaded"
                                                                        ></grid>
                                                                </div>
                                                                <div id="lastLoginInfo">
                                                                Last login {{lastLoginInfo}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                `,
    controls: [
        {
            name: 'proOppFolders',
            type: 'dropdown',
            fields: { text: 'text', value: 'value' },
            showClearButton: false
        },
        {
            name: 'proReferCheckbox',
            type: 'checkbox',
            value: true
        },
        {
            name: 'proReferButton',
            type: 'button',
            label: 'Refer',
            onclick: 'refer'
        },
        {
            name: 'proPlaceCheckbox',
            type: 'checkbox',
            value: true
        },
        {
            name: 'proPlaceButton',
            type: 'button',
            label: 'Place',
            onclick: 'place'
        },
    ]
};

const mainGridCmp = {
    name: 'mainGrid',
    preInitControls: true,
    editorSettings: editorSettings,
    data() {
        return {
            selectedFolder: {},
            selectedIds: [],
            selectedTab: false,
            tabs: [],
            psp: false,
            buttons: [],
            ffList: [],
            logoUrl: false,
            accountName: '',
            menuBarFields: {
                itemId: "name", text: "title", parentId: "parentId", iconCss: "iconCss", url: "url", separator: "separator", children: "items"
            },
            alreadyShownTabs: {},
            reloadButtons: false,
            selectedItems: {},
            selectedItemsFullData: {},
            lastLoginInfo: '',
            leftMenu: {},
            gridWrapperHeight: '100%',
            accountSettings: {},
            showFolderNameInTitle: false,
            gridLoaded: {},
            proOppSelectedFolder: 3,
            proOppFolders: []
        };
    },
    methods: {
        leftMenuItems(button) {
            let tmpItems = [];
            if (button.additionalData && button.additionalData.items && button.additionalData.items.length) {
                for (let i in button.additionalData.items) {
                    if (i === 'length') continue;
                    let tmpItem = library.cloneObj(button.additionalData.items[i]);
                    if (tmpItem.needSelected && !this.selectedItems[this.selectedTab]?.length) {
                        continue;
                    }
                    tmpItem.text = tmpItem.title;
                    tmpItem.additionalData = { action: button.additionalData.items[i].action };
                    tmpItems.push(tmpItem);
                }
            }
            return tmpItems;
        },
        getPspByAbbrev(abbrev) {
            let psp;
            abbrev = abbrev.toLowerCase();
            switch (abbrev) {
                case 'vol':
                    psp = 1;
                    break;
                case 'opp':
                    psp = 2;
                    break;
                case 'org':
                    psp = 3;
                    break;
                case 'mem':
                    psp = 5;
                    break;
                case 'pro':
                    psp = 14;
                    break;
                case 'dashboard':
                    psp = 'dashboard';
                    break;
            }
            return psp;
        },
        disableControls() {
            let buttons = this.leftMenu[this.selectedTab];
            let selectedCount = this.selectedItems[this.selectedTab] ? this.selectedItems[this.selectedTab].length : 0;
            let isRecycleBin = this.selectedFolder[this.selectedTab] && this.selectedFolder[this.selectedTab].VIEW_TYPE_ID === 6;
            if (this.psp === 14) {
                let disabled = true;
                if (this.selectedItems[this.selectedTab]
                    && this.selectedItems[this.selectedTab].length
                    && this.selectedItems['COORD_PRO_OPP']
                    && this.selectedItems['COORD_PRO_OPP'].length
                ) {
                    disabled = false;
                }
                for (let i in this.controls) {
                    if (i === 'length') continue;
                    if (this.controls[i].name === 'proOppFolders') continue;
                    this.controls[i].disabled = disabled;
                }
            }
            for (let i in buttons) {
                if (i === 'length') continue;
                if (this.controls[buttons[i].value]) {
                    let disable = false;
                    let display = true;
                    if (buttons[i].additionalData) {
                        display = false;
                        if ((!selectedCount && buttons[i].additionalData.needSelected) || (selectedCount !== 1 && buttons[i].additionalData.needOneSelected)) {
                            disable = true;
                        } else {
                            disable = false;
                        }
                        if ((!isRecycleBin && typeof buttons[i].additionalData.showInRecycleBinOnly === 'undefined' && typeof buttons[i].additionalData.showInRecycleBin === 'undefined')
                            || (isRecycleBin && buttons[i].additionalData.showInRecycleBinOnly)
                            || (buttons[i].additionalData.showInRecycleBin)
                            || (!isRecycleBin && buttons[i].additionalData.showInRecycleBin)
                        ) {
                            display = true;
                        }
                    }
                    this.controls[buttons[i].value].disabled = disable;
                    this.controls[buttons[i].value].display = display;
                }
            }
        },
        async onLoad() {
            ddStore.preloadGroup('COMMON');
            ddStore.preloadGroup('VOLUNTEER');
            ddStore.preloadGroup('DATA_GRID');
            this.accountSettings = await configStore.getAccountSettings();
            if (this.accountSettings.ACCOUNT_ID) {
                let customCssUrl = PROJECTS_URL + '/custom/coordinator/' + this.accountSettings.ACCOUNT_ID + '/css.css';
                let customCssIsExist = await sDs.get(customCssUrl, true);
                if (customCssIsExist) {
                    let link = document.createElement('link');
                    link.setAttribute('rel', 'stylesheet');
                    link.setAttribute('href', customCssUrl);
                    document.head.appendChild(link);
                }
            }
            if (parseInt(this.accountSettings.ACCOUNT_FOLDERNAME_IN_TITLE, 10)) {
                this.showFolderNameInTitle = true;
            }
            window.addEventListener('resize', () => {
                this.getWrapperHeight();
            }, true);
            this.getWrapperHeight();
            this.ffList = await configStore.getAllClientFFList();
            if (this.ffList.COORDINATOR) {
                if (!this.selectedTab && this.tabs) this.selectedTab = this.ffList.COORDINATOR[0].value;
            }
            this.processTab(this.selectedTab);
        },
        prepareTabs(tabs) {
            let tmpTabs = [];
            let tmpPages = {};
            for (let i in tabs) {
                if (i === 'length') continue;
                if (tabs[i].FF_CONSTANT === "COORD_DASHBOARD" && !this.accountSettings.ACCOUNT_EC_DASHBOARD_ID) continue;
                let tmpTab = tabs[i];
                tmpTab.psp = this.getPspByAbbrev(tabs[i].FF_CONSTANT.replace('COORD_', ''));
                tmpTab.abbrev = tabs[i].FF_CONSTANT.replace('COORD_', '');
                tmpTab.title = tabs[i].FF_ALIAS || tabs[i].FF_NAME;
                tmpPages[tabs[i].FF_CONSTANT] = 1;
                tmpTabs.push(tmpTab);
            }
            this.tabs = tmpTabs;
        },
        prepareLeftMenu(buttons) {
            let tmpButtons = [];
            this.reloadButtons = true;
            let tmpControls = [];
            for (let i in buttons) {
                if (i === 'length') continue;
                if (buttons[i].title.indexOf('Reports') !== -1) buttons[i].title = 'Reports';
                tmpButtons.push({
                    text: buttons[i].title,
                    value: buttons[i].name,
                    additionalData: library.cloneObj(buttons[i])
                });
                if (typeof buttons[i].items !== 'undefined' || buttons[i].type === 'automation' || buttons[i].type === 'logbook') {
                    let tmpItems = [];
                    if (buttons[i].items) {
                        for (let j in buttons[i].items) {
                            if (j === 'length') continue;
                            tmpItems.push({
                                text: buttons[i].items[j].title,
                                value: buttons[i].items[j].name,
                                additionalData: library.cloneObj(buttons[i].items[j])
                            });
                        }
                    }
                    tmpControls.push(
                        {
                            name: buttons[i].name,
                            type: 'dropdownbutton',
                            label: buttons[i].title,
                            width: '100%',
                            items: tmpItems,
                            onselect: this.leftMenuAction
                        }
                    );
                } else {
                    tmpControls.push(
                        {
                            name: buttons[i].name,
                            type: 'button',
                            label: buttons[i].title,
                            width: '100%'
                        }
                    );
                }
            }
            this.reloadButtons = false;
            tmpControls.forEach((control) => {
                let controlStoreIndex = createStoreIndex(this.storeId, control.name);
                controlStore().addControl(control, this, controlStoreIndex);
            });
            this.leftMenu[this.selectedTab] = tmpButtons;
        },
        async processTab(tab) {
            library.showLoadingIndicator('grid-main-content');
            this.selectedTab = tab;
            let loadOnlyLeftMenu = true;
            if (library.objIsEmpty(this.alreadyShownTabs)) loadOnlyLeftMenu = false;
            this.alreadyShownTabs[tab] = 1;
            this.psp = this.getPspByAbbrev(this.selectedTab.replace('COORD_', ''));
            let psp = this.psp === 'dashboard' ? 1 : this.psp;
            let params = ['logo', 'menuLeft', 'lastLoginInfo', 'tabs'];
            if (loadOnlyLeftMenu) params = ['menuLeft'];
            if (this.psp === 14) params.push('folders');
            let mainGridData = await this.sDs.post('ec_getMainGridInfo', psp, params);
            if (mainGridData.data) {
                mainGridData = mainGridData.data;
            } else {
                return;
            }
            if (mainGridData.logo) {
                this.logoUrl = mainGridData.logo.image;
                this.accountName = mainGridData.logo.name;
            }
            if (mainGridData.folders) {
                this.prepareFolders(mainGridData.folders);
            }
            this.$nextTick(() => {
                this.getWrapperHeight();
            });

            if (mainGridData.menuLeft) {
                this.prepareLeftMenu(mainGridData.menuLeft);
            }
            if (mainGridData.lastLoginInfo) this.lastLoginInfo = mainGridData.lastLoginInfo;
            if (mainGridData.tabs) {
                this.prepareTabs(mainGridData.tabs);
            }
            this.disableControls();
            library.hideLoadingIndicator('grid-main-content');
        },
        prepareFolders(folders) {
            let proOppFolders = [];
            for (let i in folders) {
                if (i === 'length') continue;
                if (folders[i].VIEW_TYPE_ID === 6) continue; // recycle bin
                proOppFolders.push({
                    text: folders[i].DATA_VIEW_NAME,
                    value: folders[i].DATA_VIEW_ID,
                });
            }
            this.proOppFolders = proOppFolders;
        },
        getWrapperHeight() {
            let rightPanel = document.getElementById('gridWrapper');
            let height = '100%';
            if (rightPanel) {
                height = document.documentElement.clientHeight - document.getElementById('rightpanel').offsetTop - 70; // NOSONAR
            }
            this.gridWrapperHeight = height + 'px';
        },
        async doLocalAction(refreshPrevWindow, localActionParams, fromPopUpName) {
            let reloadGrid = true;
            if (localActionParams) {
                /* let params = localActionParams.split(',');
                if (params.length) {
                    switch (params[0]) {
                        case "useFilter":
                            // eslint-disable-next-line no-case-declarations
                            let filterId = parseInt(params[1], 10);
                            if (filterId
                                && this.$refs
                                && this.$refs['grid_mainGrid__' + this.selectedTab]
                                && this.$refs['grid_mainGrid__' + this.selectedTab][0]
                                && typeof this.$refs['grid_mainGrid__' + this.selectedTab][0].filterChange === 'function'
                            ) {
                                this.$refs['grid_mainGrid__' + this.selectedTab][0].filterChange(filterId);
                                reloadGrid = false;
                            }
                            break;
                    }
                } */
            }
            if (fromPopUpName === 'adminOption') {
                this.accountSettings = await configStore.getAccountSettings();
                this.showFolderNameInTitle = !!parseInt(this.accountSettings.ACCOUNT_FOLDERNAME_IN_TITLE, 10);
                reloadGrid = false;
            }
            if (reloadGrid) {
                this.getGridData(true);
            }
            // this.processTab(this.selectedTab);
        },
        getGridData(flag) {
            if (this.$refs
                && this.$refs['grid_mainGrid__' + this.selectedTab]
                && this.$refs['grid_mainGrid__' + this.selectedTab][0]
                && typeof this.$refs['grid_mainGrid__' + this.selectedTab][0].getGridData === 'function'
            ) {
                this.$refs['grid_mainGrid__' + this.selectedTab][0].getGridData(flag);
            }
        },
        reloadGrid(ref) {
            if (this.$refs && this.$refs[ref] && typeof this.$refs[ref].getGridData === 'function') {
                this.$refs[ref].getGridData(true);
            }
        },
        async doAction(act, params) {
            if (!params) params = {};
            params.openInSameWindow = true;
            params.psp = this.psp;
            params.isMainGrid = true;
            params.actVal = act;
            if (act === 'logout' || act === "'about'" || act === 'dashboard' || act === 'refresh') {
                if (act === 'dashboard') {
                    this.selectedTab = 'COORD_DASHBOARD';
                    this.processTab(this.selectedTab);
                } else if (act === 'logout') {
                    actionStore.logout({ psp: 'user' });
                } else if (act === "'about'") {
                    actionStore.openAbout();
                } else if (act === 'refresh') {
                    this.processTab(this.selectedTab);
                }
                return;
            }
            if (params.recordId) {
                this.selectedItems[this.selectedTab] = [params.recordId];
            }
            params.recordId = this.selectedItems[this.selectedTab];
            switch (act) {
                case 'delete':
                    params._this = this;
                    params.functionOnSuccess = (response) => {
                        this.getGridData(true);
                    };
                    break;
                case 'copy':
                    params._this = this;
                    params.functionOnSuccess = (response) => {
                        if (params.recordId.length > 1) {
                            this.getGridData(true);
                        } else {
                            this.doAction('edit', { recordId: response.data[0] });
                        }
                    };
                    break;
            }
            params.doLocalAction = this.doLocalAction;
            let tmpActName = 'open' + library.capitalizeFirstLetter(act);
            let tmpActNameEntity = act + 'Entity';
            /* end popup width section */
            if (act.indexOf('HelpMenu') !== -1) {
                actionStore.openHelpMenu(params);
            } else if (typeof actionStore[tmpActName] === 'function') {
                actionStore[tmpActName](params);
            } else if (typeof actionStore[tmpActNameEntity] === 'function') {
                actionStore[tmpActNameEntity](params);
            } else {
                actionStore.actions.iframeProcessSubmit(act, params, params.width, params.height);
            }
        },
        doMenuAction(menu) {
            let records = this.selectedItems && this.selectedItems[this.selectedTab] && this.selectedItems[this.selectedTab].length ? this.selectedItems[this.selectedTab].join(',') : "";
            let params = {};
            let act = menu.action;
            if (typeof act === 'object') {
                params = library.cloneObj(act);
                act = params.act || params.class + ';' + params.psp + ';' + records;
            }
            params.recordId = records;
            params.fromTopMenu = true;
            if (menu.ITEM_URL && menu.ITEM_URL.indexOf('mailto:') !== -1) {
                window.open(menu.ITEM_URL);
                return;
            }
            this.doAction(act, params);
        },
        leftMenuAction(event, button) {
            let act;
            let records = this.selectedItems && this.selectedItems[this.selectedTab] && this.selectedItems[this.selectedTab].length ? this.selectedItems[this.selectedTab].join(',') : "";
            let params = {};
            if (event && event.item && event.item.additionalData && event.item.additionalData.action) {
                if (typeof event.item.additionalData.action === 'object') {
                    params = library.cloneObj(event.item.additionalData.action);
                    act = params.act || params.class + ';' + params.psp + ';' + records;
                } else {
                    act = event.item.additionalData.action;
                }
            }
            if (button && button.name && button.type !== 'dropdownbutton') {
                let tmpButton = this.leftMenu[this.selectedTab].find((tmpButton) => tmpButton.value === button.name);
                if (tmpButton && tmpButton.additionalData) {
                    act = tmpButton.additionalData.type;
                }
            }
            params.recordId = records;
            if (act) {
                this.doAction(act, params);
            }
        },
        onGridLoaded() {
            setTimeout(() => {
                this.$nextTick(() => {
                    this.gridLoaded[this.selectedTab] = true;
                    this.$nextTick(() => {
                        this.disableControls();
                    });
                });
            }, 500);
        },
        place() {
            if (this.psp !== 14) return;
            let oppIDs = this.selectedItems['COORD_PRO_OPP'] || [];
            let recordsIDs = this.selectedItems[this.selectedTab] || [];
            if (oppIDs.length && recordsIDs.length) {
                let params = {
                    oppIDs: oppIDs,
                    recordsIDs: recordsIDs,
                    doLocalAction: this.doLocalAction,
                    recordsPsp: 14
                };
                actionStore.place(params);
            }
        },
        refer() {
            if (this.psp !== 14) return;
            let oppIDs = this.selectedItems['COORD_PRO_OPP'] || [];
            let recordsIDs = this.selectedItems[this.selectedTab] || [];
            if (oppIDs.length && recordsIDs.length) {
                let params = {
                    oppIDs: oppIDs,
                    recordsIDs: recordsIDs,
                    doLocalAction: this.doLocalAction,
                    recordsPsp: 14
                };
                actionStore.refer(params);
            }
        }
    },
    components: {
        menuBar: defineAsyncComponent(() => import('@common/menuBar.vue')),
        foldersManager: defineAsyncComponent(() => import('@common/foldersManager.vue')),
    }
};

componentStore.initComponent(mainGridCmp, mainGridCfg);
export { mainGridCfg, mainGridCmp };
export default mainGridCmp;
</script>

<style lang="css">
@import "~@common/global.css";
@import "~@assets/css/utilities.css";
@import "~@assets/css/fonts.css";
</style>

<style scoped>
:deep(.container-fluid),
:deep(.container-sm),
:deep(.container-md),
:deep(.container-lg),
:deep(.container-xl) {
    padding: 0;
}

:deep(#vms) {
    font-family: "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif!important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 0;
    font-size: 16px !important;
    height: 100vh;
}

:deep(#grid-main-content-inner) {
    display: flex;
}

:deep(#leftpanel) {
    min-width: 155px;
}

:deep(#rightpanel) {
    flex-grow: 9;
    display: block;
    width: 90%;
    background: #fff;
}

:deep(#grid-main-content .control.e-control button) {
    text-transform: none;
}

:deep(.grid-sg-list),
:deep(.grid-filter-list) {
    width: 540px;
}

:deep(.grid-show-all),
:deep(.grid-filters) {
    width: 65px;
}

:deep(.grid-settings) {
    width: 90px;
}

:deep(.grid-show-all),
:deep(.grid-settings),
:deep(.grid-sg-list),
:deep(.grid-filters),
:deep(.grid-filter-list) {
    display: block;
    float: left;
    margin: 5px;
}

:deep(.e-row) {
    background-color: #f9f9f9;
    font-size: 13px;
    font-weight: 400;
}

:deep(.e-row *) {
    font-size: 13px;
    font-weight: 400;
}

:deep(.e-altrow) {
    background-color: #fff;
}

:deep(.e-row:hover) {
    background-color: rgb(254,255,234);
}

:deep(.e-row:hover td) {
    background-color: transparent !important;
}

:deep(.e-columnheader  *) {
    background-color: #607D8B !important;
    color: #fff;
}

:deep(.e-selectionbackground) {
    color: #303030 !important;
    background-color: #e5f7fe !important;
}

:deep(.grid-wrapper) {
    margin: 5px;
}

:deep(.e-columnheader .e-frame) {
    color: #fff !important;
    border-color: #fff !important;
}

:deep(#lastLoginInfo) {
    text-align: right;
}

:deep(.fullscreen-dialog [id^='templateDiv']),
:deep(.fullscreen-dialog [id^='templateDiv'] > div) {
    height: 100%;
}

:deep(.e-row), :deep(.e-rowcell) {
    height: 20px !important;
}

:deep(.e-rowcell),
:deep(.e-filterbarcell) {
    border-right: 1px dashed #d6d6d6 !important;
}

:deep(.e-headercelldiv) {
    text-align: center !important;
}

:deep(#gridWrapper) {
    overflow-x: auto;
    min-height: 460px;
    min-width: 1400px;
    position: relative;
}

:deep(#mainGrid #leftpanel button:disabled) {
    background-color: #e9e9e9 !important;
    border-color: #bdbdbd !important;
    color: #303030 !important;
    cursor: not-allowed !important;
    opacity: 0.5 !important;
}

:deep(#mainGrid #leftpanel #ACTION_BUTTONS button) {
    width: 135px !important;
    height: 30px !important;
    background-color: #eceff1 !important;
    border: none !important;
    margin: 1px 10px 10px 10px !important;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    box-shadow: none !important;
}

:deep(#mainGrid #rightpanel button) {
    font-family: "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif!important;
    background: #e0e0e0!important;
    color: #303030!important;
    border: 1px solid #bdbdbd!important;
    border-radius: 0!important;
    font-weight: 500!important;
    padding: 3px 5px!important;
    text-align: center!important;
    vertical-align: baseline!important;
    /*width: auto !important;*/
    height: 26px !important;
    transition: background-color 0.23s ease-in-out 0s !important;
    box-shadow: none !important;
    font-size: 13px !important;
    margin: 0 auto;
}

:deep(#mainGrid .e-headertext) {
    font-size: 13px;
    font-weight: 600;
    color: #fff !important;
    text-decoration: none !important;
}

:deep(#mainGrid .isForProfessions .e-headertext) {
    font-size: 13px;
    font-weight: 600;
    color: black !important;
    text-decoration: none !important;
}

:deep(#mainGrid #rightpanel input) {
    line-height: 14px !important;
    font-size: 13px !important;
    min-height: 14px !important;
}

:deep(#grid-main-content .e-spinner-pane) {
    background-color: #5a5a5a;
    opacity: 0.25;
}

:deep(.e-defaultcursor), :deep(.e-rhandler.e-rcursor) {
    height: 36px !important
}

:deep([name="VOLGRID_BC"]) {
    display: none;
}

:deep(.top-menu) {
    position: fixed;
    top: 0;
    z-index: 999999;
}

:deep(#main-grid-content) {
    margin-top: 46px;
}

:deep(.account-title) {
    padding-bottom: 5px;
}

:deep(#mainGrid #rightpanel #professionsButtons #ACTION_BUTTONS button) {
    width: 150px !important;
    height: 30px !important;
    background-color: #eceff1 !important;
    border: none !important;
    margin: 1px 1px 1px 1px !important;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    box-shadow: none !important;
    background-color: #eceff1 !important;
    border: none !important;
}

:deep(#mainGrid #rightpanel #professionsButtons #ACTION_BUTTONS button:disabled) {
    background-color: #e9e9e9!important;
    border-color: #bdbdbd!important;
    color: #303030!important;
    cursor: not-allowed!important;
    opacity: 0.5!important;
}

:deep(#professionsButtons .inputButtonWrapper) {
    float: left;
    margin: 0 1px 1px 1px;
}

:deep(.proPlace) {
    display: flex;
    text-align: center;
    float: right;
    width: 146px;
}

:deep(.proOpp) {
    margin: 0px 10px;
}

:deep(.proOpp *) {
    color: white !important;
}
</style>

<style>
.about-section {
    text-align: center;
}

.ref-place-choice-title {
    text-decoration: underline;
}
</style>
